import { useRef, useState } from 'react';
import createContext from 'constate';

const [SearchContextProvider, useSearch] = createContext(() => {
  const [searchText, setSearchText] = useState<string>('');
  const [shouldExpandSearchBar, setShouldExpandSearchBar] = useState(false);
  const [searchError, setSearchError] = useState<string | undefined>(undefined);
  const onSubmitCallbackRef = useRef<(() => void) | undefined>(undefined);
  const searchInputRef = useRef<HTMLInputElement | null>(null);

  const handleSearchSubmit = () => {
    if (onSubmitCallbackRef.current) {
      onSubmitCallbackRef.current();
    }
  };

  return {
    handleSearchSubmit,
    onSubmitCallbackRef,
    searchError,
    searchInputRef,
    searchText,
    setSearchError,
    setSearchText,
    setShouldExpandSearchBar,
    shouldExpandSearchBar,
  };
});

export { SearchContextProvider, useSearch };
